import Axios from '../baseApi';

export default {
  fetch() {
    return Axios.get('/api-registration/v1/registration-group');
  },
  fetchById(id) {
    return Axios.get(`/api-registration/v1/registration-group/${id}`);
  },
  addOrUpdate(form) {
    return Axios.post(`/api-registration/v1/registration-group`, form);
  },
  delete(id) {
    return Axios.delete(`/api-registration/v1/registration-group/${id}`);
  },
  move(form) {
    return Axios.post(`/api-registration/v1/registration-group/move`, form);
  }
}
